module.exports = __webpack_public_path__ + "static/media/PZ_2_etapa.0a2306c4.jpg";